function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Outline Icon");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M28.405,6.2H22.248v-2.1a2.07,2.07,0,0,0-2.067-2.067H11.929A2.07,2.07,0,0,0,9.862,4.094V6.2H3.6V8.266H5.708V26.613a3.21,3.21,0,0,0,3.027,3.36h14.62a3.21,3.21,0,0,0,3.027-3.36V8.266h2.023Zm-16.476-2.1h8.252V6.2H11.929ZM24.315,26.613c0,.7-.44,1.293-.96,1.293H8.735c-.52,0-.96-.592-.96-1.293V8.266h16.54ZM13.738,13.437V23.77a.775.775,0,1,1-1.55,0V13.437a.775.775,0,1,1,1.55,0Zm6.2,0V23.77a.776.776,0,0,1-1.551,0V13.437a.776.776,0,0,1,1.551,0Z"
});

var SvgTrash = function SvgTrash(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Assets",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTrash, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/trash.f80c4781.svg";
export { ForwardRef as ReactComponent };